import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReminderStore } from './store/reminders-store';
import { RemindersListComponent } from './components/reminders-list/reminders-list.component';
import { ManipulationsToolbarComponent } from "../../shared/components/manipulations-toolbar/manipulations-toolbar.component";
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { PageTypeEnum } from 'src/app/shared/models/filter.model';

@Component({
    selector: 'que-reminders',
    providers: [ReminderStore, ManipulationsToolbarStore],
    templateUrl: './reminders.component.html',
    styleUrls: ['./reminders.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RemindersListComponent, TranslateDirective, TranslatePipe]
})
export class RemindersComponent implements OnInit {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);

  ngOnInit(): void {
    this.#manipulationsToolbarStore.updatePageType(PageTypeEnum.Reminders);
  }
}
